import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as message from '../message'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: message.RESOURCE.payload.dimension.partialId,
      partialId: message.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: [],
    description:
      'The info list as it stood before entries became records of their own. Read by the migration that expands it into those records, and by nothing else',
    isOptional: false,
    name: 'Info',
    partialId: PartialId.Standard.create('info'),
    type: core.common.value.types.Intrinsic.List,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
